import React from "react";
import {
  useWebViewContext,
  WEBVIEW_MESSAGE_TYPE,
} from "~/context/WebViewContext";

interface ExternalLinkProps {
  href?: string;
  children: React.ReactNode;
  aClass?: string;
}

export default function ExternalLink({
  href,
  children,
  aClass = "underline",
}: ExternalLinkProps) {
  const { isWebView, sendWebViewMessage } = useWebViewContext();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isWebView) {
      e.preventDefault();
      sendWebViewMessage(WEBVIEW_MESSAGE_TYPE.EXTERNAL_LINK, {
        url: href,
      });
    }
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={aClass}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
